import { useAuth } from '@/features/auth/stores/auth.store'
import { useEffect } from 'react'
import { syncService } from './SyncService'

export const SyncProvider = ({ children }: { children: React.ReactNode }) => {
    const { user } = useAuth()

    useEffect(() => {
        if (user) {
            syncService.setUserId(user.uid)
            const handleReconnect = () => {
                void syncService.processQueue()
            }

            window.addEventListener('online', handleReconnect)

            const interval = setInterval(() => {
                void syncService.processQueue()
            }, 10000)

            return () => {
                clearInterval(interval)
                window.removeEventListener('online', handleReconnect)
                syncService.setUserId(null)
            }
        } else {
            syncService.setUserId(null)
        }
    }, [user])

    return <>{children}</>
}
